<div class="custom-security-link">
    <a [routerLink]="['/voice-tree']">New Call Tree</a>
</div>
<div class="margin-all-area">
    <div class="home-dashboard-section">
        <div class="row-panel">
            <div class="col-left-panel" style="max-width:100%">
                <div class="wraper-main-section">
                    <div class="global-card-section">
                        <div class="global-header-section">
                            <div class="svg-icon-panel">
                                <div><img src="../../../../assets/btnVoiceCall.svg" class="mr-1" />Call Tree List</div>
                            </div>
                            <div class="header-button-panel">
                                <div class="button-wrapper">
                                    <button type="button" matTooltip="create new call tree" class="icon-btn" [routerLink]="['/voice-tree']">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                        <span class="btn-text-new">New</span>
                                        <span class="btn-text">Add</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="message-info">Total Records found: {{voiceTreeList?.length}}</div>

                        <div *ngIf="message" [ngClass]="'alert alert-' + messageType" [innerHTML]="message"></div>

                        <div class="global-body-section">
                            <div>
                                <table mat-table [dataSource]="voiceTreeListSource" class="mat-elevation-z8" matSort (matSortChange)="_localService.setSortState($event, 'view_voiceTreeList_grid')">

                                    <ng-container matColumnDef="srNo">
                                        <th mat-header-cell *matHeaderCellDef style="width: 60px;">
                                            
                                        </th>
                                        <td mat-cell *matCellDef="let row; let i = index">
                                            {{ getSerialNumber(i) }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="name">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Call Tree </th>
                                        <td mat-cell *matCellDef="let dataItem">
                                            <div class="customer-name">
                                                <a class="webkit-any-link" [routerLink]="['/voice-tree', dataItem.voiceTreeID]" [style.color]="'#1c0dbf'">{{ dataItem.name }}</a>
                                            </div>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="isActive">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                                        <td mat-cell *matCellDef="let dataItem">
                                            <div class="customer-name">
                                                <span [ngClass]="{ 'smallgreen': dataItem.isActive, 'smallred': !dataItem.isActive }">
                                                    {{ dataItem.isActive ? 'Active' : 'Not-Active' }}
                                                </span>
                                            </div>
                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="voiceTreeListDisplayColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: voiceTreeListDisplayColumns;"></tr>
                                </table>

                                <mat-paginator *ngIf="voiceTreeList?.length > 0" [pageSize]="50" (page)="_localService.setPageSize($event, 'view_voiceTreeList_grid')"
                                               [length]="voiceTreeList?.length" [pageSizeOptions]="[10, 50, 100, 200]">
                                </mat-paginator>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
